import zustand from 'zustand'
import englishLocaleData from 'lang/en.json'

const localesMap = {
  en_US: 'en',
  en_GB: 'en',
  cz_CZ: 'cs',
  da_DK: 'da',
  de_DE: 'de',
  es_ES: 'es',
  fi_FI: 'fi',
  fr_FR: 'fr',
  hu_HU: 'hu',
  it_IT: 'it',
  ja_JP: 'ja',
  ko_KR: 'ko',
  lt_LT: 'lt',
  no_NO: 'no',
  nl_NL: 'nl',
  pl_PL: 'pl',
  pt_PT: 'pt',
  ru_RU: 'ru',
  sv_SE: 'sv',
  tr_TR: 'tr',
  vi_VN: 'vi',
  zh_CN: 'zh-Hans',
  zh_TW: 'zh-Hant',
}

const loadDynamicLocaleModule = (locale: string) => {
  switch (locale) {
    case 'cs':
      return import('lang/cs.json')
    case 'da':
      return import('lang/da.json')
    case 'de':
      return import('lang/de.json')
    case 'es':
      return import('lang/es.json')
    case 'fi':
      return import('lang/fi.json')
    case 'fr':
      return import('lang/fr.json')
    case 'hu':
      return import('lang/hu.json')
    case 'it':
      return import('lang/it.json')
    case 'ja':
      return import('lang/ja.json')
    case 'ko':
      return import('lang/ko.json')
    case 'lt':
      return import('lang/lt.json')
    case 'no':
      return import('lang/no.json')
    case 'nl':
      return import('lang/nl.json')
    case 'pl':
      return import('lang/pl.json')
    case 'pt':
      return import('lang/pt.json')
    case 'ru':
      return import('lang/ru.json')
    case 'sv':
      return import('lang/sv.json')
    case 'tr':
      return import('lang/tr.json')
    case 'vi':
      return import('lang/vi.json')
    case 'zh-Hans':
      return import('lang/zh-Hans.json')
    case 'zh-Hant':
      return import('lang/zh-Hant.json')
    default:
      return null
  }
}

type State = {
  locale: string
  defaultLocale: string
  loadMessages: () => PromiseLike<any>
  updateLocale: (locale: keyof typeof localesMap | undefined) => void
}

const useLocale = zustand<State>((set, get) => ({
  locale: 'en',
  defaultLocale: 'en',
  loadMessages: async () => {
    const { locale } = get()
    const data = await loadDynamicLocaleModule(locale)
    if (!data) {
      return englishLocaleData
    }
    return data.default
  },
  updateLocale: (locale) => {
    if (locale !== undefined) {
      set({ locale: localesMap[locale] || 'en' })
    }
  },
}))

export default useLocale
